import React from "react";
import ReactDOM from "react-dom";
import "typeface-roboto";
import "bootstrap/dist/css/bootstrap.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ConnectedRouter } from "connected-react-router";
import configureStore from "./store/configureStore";
import { history } from "./store/history";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ScrollToTop } from "./helpers";
import { HashRouter } from "react-router-dom";

ReactDOM.render(
  <Provider store={configureStore().store}>
    <ConnectedRouter history={history}>
      <HashRouter>
        <PersistGate loading={null} persistor={configureStore().persistor}>
          <ScrollToTop />
          <App />
        </PersistGate>
      </HashRouter>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
